// extracted by mini-css-extract-plugin
export var reservarAhoraButton = "ReservarAhoraButton-module--reservar-ahora-button--zfqBR";